<template>
  <div class="container">
    <div class="checkbox_toolbar">
      <button type="button" class="checkbox_toolbar_cancel" @click="onCancel">
        取消</button
      ><button
        type="button"
        class="checkbox_toolbar_confirm"
        @click="onConfirm"
      >
        确认
      </button>
    </div>
    <div class="checkbox_columns">
      <div class="checkbox_column">
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in list"
              clickable
              :key="item.schoolId"
              :title="`${item.schoolName}`"
              @click="toggle(index)"
            >
              <template #right-icon>
                <van-checkbox :name="item" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  data() {
    return {
      list: [],
      result: [],
    };
  },
  props: {
    maintainAreas: Array,
    checkedMaintainAreas: Array,
  },
  created() {
    this.list = this.maintainAreas;
    // this.result = this.checkedMaintainAreas;
  },
  mounted() {
    // this.$refs.checkboxes[0].toggle();
    // this.$refs.checkboxes[1].toggle();
    for (const key in this.maintainAreas) {
      this.checkedMaintainAreas.map((v) => {
        if (v.schoolId == this.maintainAreas[key].schoolId) {
          this.$refs.checkboxes[key].toggle();
        }
      });
    }
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    onConfirm() {
      this.$emit("onConfirm", this.result, false);
    },
    onCancel() {
      // console.log(this.maintainAreas)
      this.$emit("onCancel", false);
    },
  },
};
</script>

<style scoped>
.container {
  padding: 10px 30px;
}
.checkbox_toolbar {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  height: 60px;
}
.checkbox_toolbar_cancel,
.checkbox_toolbar_confirm {
  height: 100%;
  padding: 0 32px;
  font-size: 28px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.checkbox_toolbar_cancel {
  color: #969799;
}
.checkbox_columns {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 480px;
  /* padding: 30px 0; */
  box-sizing: border-box;
}
.checkbox_column {
  /* display: flex; */
  /* height: 300px; */
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  overflow-y: scroll;
  font-size: 32px;
}
</style>